// extracted by mini-css-extract-plugin
export default {"input":"CouponForm_input__S9KCv","button":"CouponForm_button__aGWN9"};